var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"error-page"},[_c('h2',{staticClass:"headline text-yellow"},[_vm._v(" 404")]),_c('div',{staticClass:"error-content"},[_c('h3',[_c('i',{staticClass:"fa fa-warning text-yellow"}),_vm._v(" Oops! Page not found.")]),_c('p',[_vm._v(" We could not find the page you were looking for. ")])])])])
}]

export { render, staticRenderFns }